angular.module('rjmNg.directives').directive 'columnEditor', [
  () ->
    restrict:"E"
    templateUrl: "directive.columnEditor.html"
    priority: 200
    scope:
      table: "="
      pristine: "="
      editingColumn: "="
    require: "^?rjmUi"
    controllerAs: "view"
    bindToController: true
    controller: [
      "$anchorScroll"
      "$rootScope"
      "rjdl"
      "ceDefaultDefinitions"
      "logger"
      "changelog"
      "columnErrorService"
      "notification"
      "rjdlDefinitionInjector"
      (
        $anchorScroll
        $rootScope
        rjdl
        ceDefaultDefinitions
        logger
        changelog
        columnErrorService
        notification
        rjdlDefinitionInjector
      ) ->

        view = @

        # All of the editable columns for the currently selected table.
        view.column = null
        view.lastEditColumn = null

        # Whether an operation is in progress and the user should be prevented
        # from doing/modifiying anything.
        view.loading = false
        view.changed = false
        view.columnIsValid = false

        _updateEditingColumn = (editingColumn) ->
          if view.editingColumn?
            view.editingColumn = editingColumn

        _getMeta = (response) ->
          changelog.getMetaFromColumnResponse(response)

        _getEvent = (action) ->
          changelog.getEventTypeFromJournalAction(action)

        # Create a new column for editing.
        _createColumn = () ->
          view.column = angular.copy(ceDefaultDefinitions.field)
          view.setFocus()

        # Called if the promise has been rejected.
        _errorHandler = (error) ->
          notification.error("", "#{error.title}: #{error.message}", "data-warehouse-notifications")
          view.loading = false

        # Hide the column editor.
        view.cancel = () ->
          view.pristine = true
          view.column = null
          view.lastEditColumn = null
          _updateEditingColumn(false)
          $rootScope.$broadcast 'clearPreviewColumn'

        # Called when the save button is clicked. Save the column.
        view.submit = () =>
          view.loading = true
          view.columnChanged()

          funcToCall = if view.column.id? then rjdl.save else rjdl.create
          action = if view.column.id? then 'edit' else 'create'

          funcToCall(view.table, view.column).then(
            (response) ->
              view.pristine = true
              logger.log('Column Editor Usage', 'Save', 1, action)
              view.loading = false
              $rootScope.$broadcast 'columnEditorSave'
              _updateEditingColumn(false)
              changelog.save(response.id, 'local_column', _getEvent(action), _getMeta(response))
              view.cancel()
            , (error) ->
              # Translate errors into readable messages
              readable_messages = columnErrorService.get(error.message)
              error.message = readable_messages
              _errorHandler(error)
              $anchorScroll('columnEditor')
          )

        # Tell the data warehouse controller to show the tab pane containing
        # the column editor.
        view.setFocus = () ->
          $rootScope.$broadcast('showColumnEditor')

        $rootScope.$on 'createColumn', (event) ->
          view.pristine = true

          logger.log('Column Editor Usage', 'Open', 1, 'create')
          _createColumn()
          _updateEditingColumn(true)

        $rootScope.$on 'editColumn', (event, columnId) ->
          view.pristine = true

          # Add an empty column while waiting for the new column to load
          _createColumn()
          view.loading = true
          _updateEditingColumn(true)
          logger.log('Column Editor Usage', 'Open', 1, 'edit')

          rjdl.fromColumnId(columnId).then(
            (column) ->
              view.column = angular.copy(column)
              view.loading = false
            , _errorHandler
          )

        $rootScope.$on 'cancelEditing', (event) ->
          if view.column?
            view.cancel()

        view.columnChanged = () ->
          if not view.lastEditColumn?
            view.lastEditColumn = angular.copy(view.column)
          newColumn = angular.copy(view.column)

          view.changed = not angular.equals(newColumn, view.lastEditColumn)

          if view.changed
            view.pristine = false
            view.lastEditColumn = angular.copy(view.column)
          else
            view.pristine = true

        view.checkColumnValidity = () ->
          unless view.column?.definition?
            view.columnIsValid = false
            return

          converter = null
          valid = true

          if view.column?.definition?
            converter =
              rjdlDefinitionInjector.getConverterForType(view.column.definition)

          try
            converter.validateField(view.column)
          catch e
            valid = false

          view.columnIsValid = valid

        view
    ]
    link: (scope, element, attributes, rjmUi) ->
      view = scope.view

      # Watch the associated column and determine whether it has changed
      # compared to the pristine column.
      scope.$watch 'view.column', () ->
        view.columnChanged()
        view.checkColumnValidity()
      , true

      scope.$watch "view.loading", () ->
        rjmUi?.loadingUi "data-warehouse", scope.view.loading

]
